module.exports = __webpack_public_path__ + "src/assets/img/prius-img.5d7bf8d1.png";